<template>
  <span :title="JSON.stringify(value)">{{userAgentLabel}}</span>
</template>

<script>
export default {
    name : 'UserAgent',

    props : ['value'],

    computed : {
        userAgentLabel() {
            return this.buildOriginLabel();
        }
    },

    methods : {
        buildOriginLabel() {
            if ( !this.value || !this.value.id ) {
                return '空';
            }

            if ( !this.value.userAgent ) {
                return 'NOUA';
            }

            var userAgentLabel = this.buildOriginLabel_2(this.value.userAgent);
            if ( !!userAgentLabel ) {
                return userAgentLabel;
            }

            // gd@itaojin.cn
            if ( !!this.value.referer ) {
                return this.value.referer;
            }

            return this.value.id;
        },

        buildOriginLabel_2( _userAgent ) {
            if ( _userAgent.indexOf('iPhone OS 11_0') > -1 ) {
                return 'iPhone11';
            }

            if ( _userAgent.indexOf('iPhone OS 10_3') > -1 ) {
                return 'iPhone10.3';
            }

            if ( _userAgent.indexOf('iPhone OS 10') > -1 ) {
                return 'iPhone10';
            }

            if ( _userAgent.indexOf('iPhone OS') > -1 ) {
                return 'iPhone';
            }

            if ( _userAgent.indexOf('Windows NT 10') > -1 ) {
                return 'Win10';
            }

            if ( _userAgent.indexOf('Windows NT 6.1') > -1 ) {
                return 'Win7';
            }

            if ( _userAgent.indexOf('Windows NT 6.2') > -1 ) {
                return 'Win8';
            }

            if ( _userAgent.indexOf('Windows NT') > -1 ) {
                return 'Win';
            }

            if ( _userAgent.indexOf('Mac OS X 10_15') > -1 ) {
                return 'Mac15';
            }

            if ( _userAgent.indexOf('Mac OS X') > -1 ) {
                return 'Mac';
            }

            if ( _userAgent.indexOf('Android 9') > -1 ) {
                return 'Android9';
            }

            if ( _userAgent.indexOf('Android 10') > -1 ) {
                return 'Android10';
            }

            if ( _userAgent.indexOf('Android 8') > -1 ) {
                return 'Android8';
            }

            if ( _userAgent.indexOf('Android 7') > -1 ) {
                return 'Android7';
            }

            if ( _userAgent.indexOf('Android 5') > -1 ) {
                return 'Android5';
            }

            if ( _userAgent.indexOf('Android') > -1 ) {
                return 'Android';
            }

            if ( _userAgent.indexOf('Java/1.8.0_144') > -1 ) {
                return 'Java8';
            }

            if ( _userAgent.indexOf('Java') > -1 ) {
                return 'Java';
            }

            if ( _userAgent == 'RPC' ) {
                return 'RPC';
            }

            if ( _userAgent == 'Mozilla/4.0' ) {
                return 'Mozilla4';
            }

            if ( _userAgent == 'Unknown' ) {
                return '未知';
            }

            return _userAgent;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/UserAgent.vue